import numberFormat from "./NumberFormat";
import Stats from "./Stats";

const precision = 3;

function pickRandomStat() {
        const i = Math.floor(Math.random() * Stats.stats.length);
        return Stats.stats[i];

}

class Imaginary {
    constructor(real, imag = 0) {
        if (typeof(real) === "number") {
            this.real = real;
            this.imag = imag;
        }
        else {
            this.real = real.real;
            this.imag = real.imag;
        }
    }

    toString() {
        if (this.imag === 0) {
            return this.real.toString();
        }
        if (this.real === 0) {
            return this.imag.toString() + "i";
        }

        let sign = "+";
        if (this.imag < 0)
            sign = "-";

        return this.real.toString() + sign + Math.abs(this.imag).toString() + "i";
    }

    numberFormat(formatter) {
        if (this.imag === 0) {
            return formatter(this.real);
        }
        if (this.real === 0) {
            return formatter(this.imag) + "i";
        }

        let sign = "+";
        if (this.imag < 0)
            sign = "-";

        return formatter(this.real) + sign + formatter(Math.abs(this.imag)) + "i";
    }

    mag() {
        return Math.sqrt(this.real * this.real + this.imag * this.imag);
    }
}

function add(x, y) {
    if (typeof(x) === "number" && typeof(y) === "number") {
        return x + y;
    }

    x = new Imaginary(x);
    y = new Imaginary(y);
    x.real += y.real;
    y.imag += y.imag;

    if (x.imag === 0)
        return x.real;
    return x;
}

function mult(x, y) {
    if (typeof(x) === "number" && typeof(y) === "number") {
        return x * y;
    }

    x = new Imaginary(x);
    y = new Imaginary(y);

    let ret = new Imaginary(x.real * y.real - x.imag * y.imag, x.real * y.imag + x.imag * y.real);
    if (ret.imag === 0)
        return ret.real;
    return ret;
}

function sqrt(x) {
    if (typeof(x) === "number") {
        if (x >= 0)
            return Math.sqrt(x);
        else
            return new Imaginary(0, Math.sqrt(Math.abs(x)));
    }

    const mag = x.mag();
    const term = add(x, mag);
    return mult(mult(mag, term), 1/term.mag());
}

class SimpleExpr {
    constructor(round) {
        this.stat = pickRandomStat();
        this.value = Math.floor(Math.random() * 7) - 3;
    }

    display() {
        let valStr = this.value.toString();
        if (this.value >= 0)
            valStr = "+" + valStr;

        return this.stat + " " + valStr;
    }

    run(stats) {
        stats[this.stat] = add(stats[this.stat], this.value);
    }
}
const formatter = new Intl.NumberFormat('en', {minimumFractionDigits: 0, maximumFractionDigits: 5});

class MultExpr {
    constructor(round) {
        this.stat = pickRandomStat();
        if (round > 30 && Math.random() < 0.2) {
            this.value = Math.random();
        }
        else {
            this.value = Math.floor(Math.random() * 3);
        }
    }

    display() {
        let valStr = formatter.format(this.value);

        return this.stat + " *" + valStr;
    }

    run(stats) {
        stats[this.stat] = mult(stats[this.stat], this.value);
    }
}

class CombineExpr {
    constructor(round) {
        this.stat = pickRandomStat();

        let numTerms = Math.max(1, Math.min(4, Math.floor(Math.random() * (round - 40) / 10)));
        this.terms = [];
        for (let i = 0; i < numTerms; ++i) {
            let term = {stat: pickRandomStat()};
            if (i === 0) {
                if (Math.random() < 0.8) {
                    term.operator = "+";
                }
                else {
                    term.operator = "-";
                }
            }
            else {
                const rand = Math.random();
                if (rand < 0.4)
                    term.operator = "+";
                else if (rand < 0.8)
                    term.operator = "-";
                else
                    term.operator = "*";
            }
            this.terms.push(term);
        }
    }

    display() {
        let ret = this.stat + " <- ";

        for (let i = 1; i < this.terms.length; ++i) {
            ret += "("
        }

        if (this.terms[0].operator === "-") {
            ret += "-";
        }
        ret += this.terms[0].stat;

        for (let i = 1; i < this.terms.length; ++i){
            ret += " " + this.terms[i].operator + " " + this.terms[i].stat + ")";
        }
            

        return ret;
    }

    run(stats) {
        let val = stats[this.terms[0].stat];
        if (this.terms[0].operator === "-")
            val = mult(-1, val);

        for (let i = 1; i < this.terms.length; ++i) {
            const term = this.terms[i];
            switch(term.operator) {
                case "+":
                    val = add(val, stats[term.stat]);
                    break;
                case "-":
                    val = add(val, mult(-1, stats[term.stat]));
                    break;
                case "*":
                    val = mult(val, stats[term.stat]);
                    break;
            }
        }

        stats[this.stat] = val;
    }
}

class MeanExpr {
    constructor(round) {
        const numTerms = Math.floor(Math.random() * 3) + 2;
        this.stat = pickRandomStat();
        this.terms = [];
        for (let i = 0; i < numTerms; ++i) {
            this.terms.push(pickRandomStat());
        }
    }

    display() {
        let ret = this.stat + " <- MEAN(" + this.terms[0];
        for (let i = 1; i < this.terms.length; ++i) {
            ret += ", " + this.terms[i];
        }
        return ret + ")";
    }

    run(stats) {
        let accum = 0;
        for (let term of this.terms) {
            accum = add(accum, stats[term]);
        }

        stats[this.stat] = mult(accum, 1/this.terms.length);
    }
}

class SqrtExpr {
    constructor(round) {
        this.stat = pickRandomStat();
    }

    display() {
        return "√" + this.stat;
    }

    run(stats) {
        stats[this.stat] = sqrt(stats[this.stat]);
    }
}

class FuckYouExpr {
    constructor(round) {
    }

    display() {
        return "FUCK YOU";
    }

    run(stats, decCards) {
        decCards();
    }
}

export default class Card {
    constructor(round) {
        this.expressions = [];

        let numExpr = 1;

        if (round > 20) {
            numExpr = Math.floor(Math.random() * 2) + 2;
        }
        else if (round > 4) {
            numExpr = Math.floor(Math.random() * 2) + 1;
        }


        for (let i = 0; i < numExpr; ++i) {
            this.expressions.push(this.generateExpr(round));
        }
    }

    generateExpr(round) {
        const pool = [
            {
                ctor: SimpleExpr,
                weight: 3
            }
        ];

        let totalWeight = pool[0].weight;

        if (round > 10) {
            const weight = Math.min(2, Math.floor(round / 10));
            pool.push({ctor: MultExpr, weight: weight});
            totalWeight += weight;
        }

        if (round > 50) {
            const weight = 2;
            pool.push({ctor: CombineExpr, weight: weight});
            totalWeight += weight;
        }

        if (round > 60) {
            const weight = 1;
            pool.push({ctor: MeanExpr, weight: weight});
            totalWeight += weight;
        }

        if (round > 100) {
            const weight = 1;
            pool.push({ctor: SqrtExpr, weight: weight});
            totalWeight += weight;
        }

        if (round > 150) {
            const weight = Math.sqrt((round - 150) * 0.1);
            pool.push({ctor: FuckYouExpr, weight: weight});
            totalWeight += weight;
        }

        let pick = Math.random() * totalWeight;

        for (let curr of pool) {
            if (pick < curr.weight)
                return new curr.ctor(round);

            pick -= curr.weight;
        }

        return new SimpleExpr(round);
    }

    runCard(stats, decCards) {
        for (const expression of this.expressions) {
            expression.run(stats, decCards);
            /*
            for (const stat in stats) {
                if (typeof(stats[stat]) === "number" && isNaN(stats[stat])) {
                    debugger;
                }
            }
            */
        }

    }
}
